/**
 * general.js
 *
 * 4/2018
 * GCU Web Marketing
 *
 * This file will include a number of helper functions to be used
 * throughout the website. You can import the functions individually
 * as needed to minimize the footprint to each component or module.
 */
/* eslint "prefer-template": 0 */

/**
 * Isolate tabbing
 *
 * @param node
 * @param event
 */
export const isoTabbing = (node, event, el) => {
  // All possible focusable elements
  const focusElements = node.querySelectorAll('a[href], area[href], input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"],iframe, object, embed, *[tabindex]:not(.modal), *[contenteditable]');
  const focusableElement = Array.prototype.slice.call(focusElements);

  // Check to see if theres an el param passed - Default: ''
  const mod = el ? el : '';

  // First focusable element
  const firstFocusableElement = focusableElement[0];

  // Last focusable element
  const lastFocusableElement = focusElements[focusElements.length - 1];

  // Tab key - prevent focus outside of form
  if (event.keyCode === 9) {
    // Only 1 focusable element
    if (focusableElement.length === 1) {
      event.preventDefault();
    } else if (event.shiftKey && document.activeElement === firstFocusableElement) {
      // Moving backwards with shift+tab
      event.preventDefault();
      lastFocusableElement.focus();
    } else if (document.activeElement === lastFocusableElement && mod === el) {
      // Last focusable element - shifts to an element passed in param
      event.preventDefault();
      mod.focus();
    } else if (document.activeElement === lastFocusableElement && mod === '') {
      // Last focusable element - shift to first focusable element
      event.preventDefault();
      firstFocusableElement.focus();
    }
  }
};
